import ActionTextContentField from 'FlowBuilder/components/ActionViews/ActionTextContentField'
import useActionTranslate from 'FlowBuilder/hooks/useActionTranslate';
import liquidEngine from 'FlowBuilder/components/ActionViews/liquidEngine'

export default function MonthlyUpsellPage({ actionId, config, textContent, amount, setMonthly, displayAmount, coverFee, setCoverFee, coverFeeAmount, handleBack, handleSubmit }) {
    const { fallback: {
      monthlyUpsellText: monthlyUpsellTextRaw,
      monthlyUpsellButton: monthlyUpsellButtonRaw,
      oneOffButton: oneOffButtonRaw,
      coverFeeText: coverFeeTextRaw,
      monthlyUpsellHeader,
      monthlyUpsellReturnText
    }} = useActionTranslate({ actionId});

  const monthlyUpsellText = useMemo(() => liquidEngine.parseAndRenderSync(monthlyUpsellTextRaw, { value: displayAmount(amount), amount: displayAmount(amount) }), [monthlyUpsellTextRaw, amount]);
  const monthlyUpsellButton = useMemo(() => liquidEngine.parseAndRenderSync(monthlyUpsellButtonRaw, { value: displayAmount(amount), amount: displayAmount(amount) }), [monthlyUpsellButtonRaw, amount]);
  const oneOffButton = useMemo(() => liquidEngine.parseAndRenderSync(oneOffButtonRaw, { value: displayAmount(amount), amount: displayAmount(amount) }), [oneOffButtonRaw, amount]);
  const coverFeeText = useMemo(() => liquidEngine.parseAndRenderSync(coverFeeTextRaw, { fee: displayAmount(coverFeeAmount) }), [coverFeeTextRaw, coverFeeAmount]);

    const handleMonthlyUpsell = () => {
      setMonthly(true);
      handleSubmit();
    }

    return <div className="monthly-upsell-page">
      <div className="back-link">
        <a href="#" onClick={handleBack}><SvgIconsArrowLeft variant="light" /><span>{ monthlyUpsellReturnText }</span></a>
      </div>
      <div className="progress-bar"></div>
      <h2 className="upsell-header">
        <ActionTextContentField html={monthlyUpsellHeader} slug='monthlyUpsellHeader' actionId={actionId} wysiwyg={false} />
      </h2>
      <div className="upsell-text">
        <ActionTextContentField html={monthlyUpsellText.replace(/\n/g, "<br>")} slug='monthlyUpsellText' actionId={actionId} />
      </div>
      <div className="buttons">
        <button className="monthly-btn" type="button" onClick={handleMonthlyUpsell}><ActionTextContentField html={monthlyUpsellButton} slug='monthlyUpsellButton' actionId={actionId} wysiwyg={false} /></button>
        <button className="one-off-btn" type="button" onClick={handleSubmit}><ActionTextContentField html={oneOffButton} slug='oneOffButton' actionId={actionId} wysiwyg={false} /></button>
      </div>

      <div className="cover-fee">
        <label><input type="checkbox" checked={coverFee} onChange={() => setCoverFee(!coverFee)}/><ActionTextContentField html={coverFeeText} slug='coverFeeText' actionId={actionId} /></label>
      </div>
    </div>
}
